import React from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import LinkMui from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import { useAuth } from "./../util/auth";
import CtaSection from "./CtaSection";
import PdfViewer from "./PdfViewer";
import { useState, useEffect } from "react";
import base from "../util/base";

const useStyles = makeStyles((theme) => ({
  cardContent: {
    padding: theme.spacing(3),
  },
}));

function DashboardSection(props) {
  const [report, setReport] = useState();
  const [displayReport, setdisplayReport] = useState(false);
  const [premiumReport, setPremiumReport] = useState();
  const [displayPremium, setDisplayPremium] = useState(false);

  const classes = useStyles();

  const auth = useAuth();

  useEffect(() => {
    base("Users")
      .select({
        view: "Grid view",
        filterByFormula: `{Email} = '${auth.user.email}'`,
      })
      .firstPage(function (err, records) {
        if (err) {
          console.error(err);
          return;
        }
        records.forEach(function (record) {
          setReport(record.get("Free Report"));
          setPremiumReport(record.get("Paid Report"));
          if (report) {
            setdisplayReport(true);
          }
          if (premiumReport) {
            setDisplayPremium(true);
          }
        });
      });
  }, [auth.user.email, report, premiumReport]);

  return (
    <>
      <Section
        bgColor={props.bgColor}
        size={props.size}
        bgImage={props.bgImage}
        bgImageOpacity={props.bgImageOpacity}
      >
        <Container>
          <SectionHeader title={`Hello!`} size={4} textAlign="center" />

          {auth.user.planIsActive && (
            <Box mx="auto" mb={4} maxWidth={400}>
              <Alert severity="success">
                You are subscribed to Parados+
                <span
                  role="img"
                  aria-label="party"
                  style={{ marginLeft: "10px" }}
                >
                  🥳
                </span>
              </Alert>
            </Box>
          )}

          <Grid container={true} spacing={4}>
            {/* <Grid item={true} xs={12} md={5}>
              <DashboardItems />
            </Grid> */}

            <Grid item={true} xs={12} md={12}>
              {displayReport ? (
                <PdfViewer blur="none" url={report} />
              ) : (
                <Card>
                  <CardContent className={classes.cardContent}>
                    <Box>
                      <Typography variant="h4" paragraph={true}>
                        <strong>Your report is not available yet...</strong>
                      </Typography>

                      <Typography paragraph={true}>
                        Check back soon. Or contact us{" "}
                        <LinkMui
                          component="a"
                          target="_blank"
                          href="https://www.parados.app/contact.html"
                        >
                          <strong>here</strong>
                        </LinkMui>
                      </Typography>
                      <Box mt={3}>
                        <Typography component="div">
                          <div>
                            In the mean time please feel free to check out some
                            free{" "}
                            <LinkMui component={Link} to="/resources">
                              <strong>resources</strong>
                            </LinkMui>{" "}
                          </div>
                        </Typography>
                        <Typography component="div">
                          <div>
                            To learn more about Parados and our mission visit
                            our{" "}
                            <LinkMui
                              href="https://www.parados.app/"
                              target="_blank"
                            >
                              <strong>website</strong>
                            </LinkMui>
                          </div>
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              )}
            </Grid>

            <Grid item={true} xs={12}>
              {!displayPremium && report && (
                <Card>
                  <CardContent className={classes.cardContent}>
                    <Box>
                      <Typography variant="h4" paragraph={true}>
                        <strong>
                          If you would like a more detailed report with specific
                          exercises for your biomechanics. Consider subscribing
                          to Parados+
                        </strong>
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              )}
              {/* {!displayPremium && (
                <Card>
                  <CardContent className={classes.cardContent}>
                    <Box>
                      <Typography variant="h4" paragraph={true}>
                        <strong>
                          Thank you for subscribing to Parados+! Your premium
                          report is not available yet...
                        </strong>
                      </Typography>

                      <Typography paragraph={true}>
                        A member of our team will notify you once your premium
                        report is ready! You should expect your results within a
                        week of subscribing or your assessment, whichever one
                        was done later. If you have received a notification and
                        are currently viewing this message please try refreshing
                        the page. If that doesn't work please reach out to us
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              )} */}
              {displayPremium && (
                <PdfViewer
                  type="Here is your Premium Report!"
                  blur="none"
                  url={premiumReport}
                />
              )}
            </Grid>
            {/* <Grid item={true} xs={12} md={7}>
              <UserInfo email={auth.user.email} />
            </Grid> */}
            {/* <Grid item={true} xs={12} md={5}>
              <Card>
                <CardContent className={classes.cardContent}>
                  <Box>
                    <Typography variant="h6" paragraph={true}>
                      <strong>What is this?</strong>
                    </Typography>
                    <Typography paragraph={true}>
                      The component on your left is an example UI that shows you
                      how to fetch, display, and update
                    </Typography>
                    <Typography paragraph={true}>
                      It also shows how you can limit features based on plan. If
                      you're subscribed to the "pro" or "business"
                    </Typography>
                    <Box mt={3}>
                      <Typography component="div">
                        <div>
                          You are signed in as{" "}
                          <strong>{auth.user.email}</strong>.
                        </div>

                        {auth.user.stripeSubscriptionId && (
                          <>
                            <div>
                              You are subscribed to the{" "}
                              <strong>{auth.user.planId} plan</strong>.
                            </div>
                            <div>
                              Your plan status is{" "}
                              <strong>
                                {auth.user.stripeSubscriptionStatus}
                              </strong>
                              .
                            </div>
                          </>
                        )}

                        <div>
                          You can change your account info{` `}
                          {auth.user.stripeSubscriptionId && <>and plan{` `}</>}
                          in{` `}
                          <LinkMui component={Link} to="/settings/general">
                            <strong>settings</strong>
                          </LinkMui>
                          .
                        </div>

                        {!auth.user.stripeSubscriptionId && (
                          <div>
                            You can signup for a plan in{" "}
                            <LinkMui component={Link} to="/pricing">
                              <strong>pricing</strong>
                            </LinkMui>
                            .
                          </div>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid> */}
          </Grid>
        </Container>
      </Section>
      <CtaSection
        bgColor="primary"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Interested in Parados+?"
        buttonText="See Pricing"
        buttonColor="default"
        buttonPath="/pricing"
      />
    </>
  );
}

export default DashboardSection;
